/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ChevronDownIcon = /*#__PURE__*/ createSvgIcon(
  'ChevronDownIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.996 12.75a.756.756 0 01-.281-.052.69.69 0 01-.236-.156L5.528 8.59a.705.705 0 01-.226-.538.769.769 0 01.24-.531.729.729 0 011.062 0L10 10.938l3.417-3.417a.693.693 0 01.531-.219.769.769 0 01.531.24.729.729 0 01-.007 1.068l-3.951 3.932a.756.756 0 01-.525.208z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ChevronDownIcon;
